import React, { Component } from 'react';
import language from '../../../assets/languages/language';
import { examNameAccordingToDB } from '../../../common/constant';
import ModalComponent from '../../Common/Modal';
import Cfa3SubscriptionCheck from '../../RestAPI/Cfa3Subscription';
import PartnerCfa3SubscriptionCheck from '../../RestAPI/PartnerSubscription/Cfa3Subscription';
import FD from '../../RestAPI/fetchData';
import App_data from '../../config/App_data';
import AlertMessage from '../../config/alertMessage';

/* eslint-disable*/
class Cfa3BeforeStart extends Component {
  constructor(props) {
    super(props);
    var messageTitle_cfa_3 = `<i class="icon-info icons font-2xl d-block "></i>`;

    this.state = {
      alert_status: false,
      MessageTitle: messageTitle_cfa_3,
      MessageContent: AlertMessage.messageContent_cfa_3,
      token: '',
      idname: '',
      quiz_id: this.props.params.quiz_id,
      status_send: this.props.params.status_send ? this.props.params.status_send : '',
      all_question_id: '',
      all_cases_id: [],
      question_length: '',
      timer_value: '',
      user_time_value: '',
      include_timer: '',
      questions_count: '',
      allrightanswercount: '',
      offset_send: 0,
      selectedmenu: 'cfa_3',
      cfaUnlimitedPackage: '',
      cfaUnlimitedActiveExam: '',
    };
    this.toggleAlert = this.toggleAlert.bind(this);
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  toggleAlert() {
    this.setState({
      alert_status: !this.state.alert_status,
    });
  }

  goPremium() {
    this.context.router.push({
      pathname: '/Subscribe/',
      state: {
        token: this.state.token,
        idname: this.state.idname,
        selectedMenu: this.state.selectedmenu,
      },
    });
  }

  //Function to redirect page to Create Quiz page
  _createQuizpage = () => {
    this.context.router.push({
      pathname: '/cfa3/quizzes',
      state: { token: this.state.token, idname: this.state.idname },
    });
  };

  //Function to redirect page to begin Quiz page
  _startQuizpage = () => {
    var data = { token: this.state.token, idname: this.state.idname };
    FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(async resp => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.toggleAlert();
        } else {
          this.setState({
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                const examPlanData = resp_exam.examPlan[0];
                isInArray_var = await PartnerCfa3SubscriptionCheck.checkCfa3Subscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                  examPlanData,
                );
                if (isInArray_var) {
                  this.context.router.push({
                    pathname: `/cfa3/beginquiz/${this.state.quiz_id}/${this.state.offset_send}`,
                    state: {
                      token: this.state.token,
                      idname: this.state.idname,
                      quiz_id: this.state.quiz_id,
                      offset: this.state.offset_send,
                    },
                  });
                } else {
                  this.toggleAlert();
                }
              } else {
                console.log('fail');
              }
            },
          );
        }
      } else {
        if (
          resp.profileInfo.exam_selected === '' &&
          resp.profileInfo.cfaUnlimitedPackage === '' &&
          resp.profileInfo.cfaUnlimitedActiveExam === ''
        ) {
          this.toggleAlert();
        } else {
          this.setState({
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                isInArray_var = Cfa3SubscriptionCheck.checkCfa3Subscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                );
                if (isInArray_var) {
                  this.context.router.push({
                    pathname: `/cfa3/beginquiz/${this.state.quiz_id}/${this.state.offset_send}`,
                    state: {
                      token: this.state.token,
                      idname: this.state.idname,
                      quiz_id: this.state.quiz_id,
                      offset: this.state.offset_send,
                    },
                  });
                } else {
                  this.toggleAlert();
                }
              } else {
                console.log('fail');
              }
            },
          );
        }
      }
    });
  };

  //Function to redirect page to begin Quiz page
  startQuizquestion = (item, offset_va, e) => {
    var data = { token: this.state.token, idname: this.state.idname };
    FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(async resp => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.toggleAlert();
        } else {
          this.setState({
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                const examPlanData = resp_exam.examPlan[0]; 
                isInArray_var = await PartnerCfa3SubscriptionCheck.checkCfa3Subscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                  examPlanData,
                );
                if (isInArray_var) {
                  this.context.router.push({
                    pathname: `/cfa3/beginquiz/${this.state.quiz_id}/${offset_va}`,
                    state: {
                      token: this.state.token,
                      idname: this.state.idname,
                      quiz_id: this.state.quiz_id,
                      offset: offset_va,
                    },
                  });
                } else {
                  this.toggleAlert();
                }
              } else {
                console.log('fail');
              }
            },
          );
        }
      } else {
        if (
          resp.profileInfo.exam_selected === '' &&
          resp.profileInfo.cfaUnlimitedPackage === '' &&
          resp.profileInfo.cfaUnlimitedActiveExam === ''
        ) {
          this.toggleAlert();
        } else {
          this.setState({
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                isInArray_var = Cfa3SubscriptionCheck.checkCfa3Subscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                );
                if (isInArray_var) {
                  this.context.router.push({
                    pathname: `/cfa3/beginquiz/${this.state.quiz_id}/${offset_va}`,
                    state: {
                      token: this.state.token,
                      idname: this.state.idname,
                      quiz_id: this.state.quiz_id,
                      offset: offset_va,
                    },
                  });
                } else {
                  this.toggleAlert();
                }
              } else {
                console.log('fail');
              }
            },
          );
        }
      }
    });
  };

  componentDidMount() {
    window.scroll(0, 0);
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (storage_session) {
      this.setState({
        idname: storage_session['idname'],
        token: storage_session['token'],
      });
    }
    var data = {
      idname: storage_session['idname'],
      token: storage_session['token'],
      quiz_id: this.state.quiz_id,
    };
    //Api to fetch Quiz by quiz id
    FD.callAPI(App_data.backend_api + '/cfa_3quizes/getQuize', data).then(resp => {
      if (resp.success) {
        var all_questions = JSON.parse(resp.singlequiz);
        var all_cases = JSON.parse(resp.case_id);
        var minutes = Math.floor(resp.timer_value / 60);
        this.setState({ timer_value: minutes });
        this.setState({ all_question_id: all_questions });
        this.setState({ all_cases_id: all_cases });
        this.setState({ question_length: resp.questions_count });
        this.setState({ user_time_value: resp.user_time_value });
      }
    });

    //Api to fetch all right answered on particular quiz id
    FD.callAPI(App_data.backend_api + '/cfa_3quizes/getrightAnswer', data).then(resp_count => {
      if (resp_count.success) {
        this.setState({
          allrightanswercount: resp_count.allrightanswercount.count,
        });
      } else {
        console.log(resp_count.success + '------------failure');
      }
    });
  }

  render() {
    let all_question_id = this.state.all_question_id;
    let all_cases = this.state.all_cases_id;
    let case_id_display = '';

    if (all_cases.length) {
      case_id_display = all_cases.map((items, index) => (
        <div>
          <div className='case_head'>
            <p className='margin_bottom_20 margin_top_10'>
              {language.LC().CASE}: {index + 1}
            </p>
            <a
              href='javascript: void(0)'
              className='float-right btn btn-primary'
              onClick={this.startQuizquestion.bind(this, items, index)}
            >
              {language.LC().VIEW}
            </a>
          </div>
          <div className='table-responsive'>
            <table className='table_white_bg table'>
              <thead>
                <tr className='border_top_0'>
                  <th width='90'>#</th>
                  <th>{language.LC().QUESTIONS}</th>
                  <th width='200'>{language.LC().YOURS_ANSWER}</th>
                  {/*<th>Actions</th>*/}
                </tr>
              </thead>
              <Questionfetch
                indexval={index}
                casesquestion={all_question_id[index]}
                token={this.state.token}
                idname={this.state.idname}
                quiz_id={this.state.quiz_id}
                answered_state={index}
              />
            </table>
          </div>
        </div>
      ));
    }

    let status_data = '';
    if (this.state.status_send === 'abondon') {
      var user_time = '';
      var min,
        sec = '';
      if (this.state.user_time_value < 60) {
        user_time = this.state.user_time_value + 'sec';
      } else {
        min = parseInt(this.state.user_time_value / 60);
        sec = this.state.user_time_value % 60;
        user_time = min + 'min ' + sec + 'sec ';
      }

      status_data = (
        <div className='card'>
          <div className='score_wrapper card-block'>
            <div className='row'>
              <div className='col-md-6'>
                <strong className='margin_right_20'>{language.LC().SCORE}</strong>{' '}
                <div className='score_box'>
                  {this.state.allrightanswercount}/{this.state.question_length}
                </div>
              </div>
              <div className='col-md-6 text-right'>
                <span className='margin_right_20'>{language.LC().TOTAL_TIME}:</span>{' '}
                <strong>{user_time}</strong>
              </div>
            </div>
          </div>
        </div>
      );
    }

    if (this.state.status_send === 'completed') {
      var user_time = '';
      var min,
        sec = '';
      if (this.state.user_time_value < 60) {
        user_time = this.state.user_time_value + 'sec';
      } else {
        min = parseInt(this.state.user_time_value / 60);
        sec = this.state.user_time_value % 60;
        user_time = min + 'min ' + sec + 'sec ';
      }

      status_data = (
        <div className='card'>
          <div className='score_wrapper card-block'>
            <div className='row'>
              <div className='col-md-6'>
                <strong className='margin_right_20'>{language.LC().SCORE}</strong>{' '}
                <div className='score_box'>
                  {this.state.allrightanswercount}/{this.state.question_length}
                </div>
              </div>
              <div className='col-md-6 text-right'>
                <span className='margin_right_20'>{language.LC().TOTAL_TIME}:</span>{' '}
                <strong>{user_time}</strong>
              </div>
            </div>
          </div>
        </div>
      );
    }

    let button_status = '';
    if (this.state.status_send === 'abondon') {
      button_status = (
        <button className='btn btn-primary pointer_class' onClick={this._startQuizpage.bind(this)}>
          Continue
        </button>
      );
    } else if (this.state.status_send === 'completed') {
      button_status = '';
    } else {
      button_status = (
        <button className='btn btn-primary pointer_class' onClick={this._startQuizpage.bind(this)}>
          {language.LC().BEGIN}
        </button>
      );
    }

    return (
      <div className='animated fadeIn'>
        <div className='row'>
          <div className='col-md-8 margin_bottom_20'>
            <h1 className='section_head'>
              {language.LC().QUIZ_ID}: {this.state.quiz_id}
            </h1>
          </div>
          <div className='col-md-4 text-md-right margin_bottom_20'>
            <button
              className='btn btn-primary pointer_class'
              onClick={this._createQuizpage.bind(this)}
            >
              {language.LC().CREATE_NEW_QUIZ}
            </button>
          </div>
        </div>

        {status_data}

        <div className='row'>
          <div className='col-sm-12'>
            <div className='card'>
              <div className='card-header'>
                {language.LC().SUMMARY}
                <div className='card-actions float-right'>
                  <span className='text_light margin_right_10'>{language.LC().LENGTH}</span>{' '}
                  {this.state.question_length} {language.LC().QUESTIONS}, {this.state.timer_value}{' '}
                  {language.LC().MINUTE}
                </div>
              </div>

              <div className='card-block'>
                <div className='margin_bottom_40'>
                  <p className='margin_bottom_20'>
                    <strong> {language.LC().BEFORE_STARTING} </strong>
                  </p>
                  <p>
                    {
                      language.LC()
                        .ONCE_A_QUESTION_IS_VALIDATED_IT_IS_IMPOSSIBLE_TO_CHANGE_YOUR_ANSWER
                    }
                  </p>
                  <p>
                    {
                      language.LC()
                        .YOU_CAN_ALWAYS_COME_BACK_TO_THIS_PAGE_TO_VIEW_THE_QUESTIONS_LEFT_UNANSWERED_OR_TO_NAVIGATE_THROUGH_THE_QUESTIONS
                    }
                  </p>
                  <p>
                    {
                      language.LC()
                        .IF_YOU_REQUESTED_A_TIMER_WE_STRONGLY_DISCOURAGE_YOU_TO_STOP_IT_DURING_THE_QUIZ_AS_TIME_MANAGEMENT_IS_A_KEY_FACTOR_FOR_SUCCESS
                    }
                  </p>
                  <p>
                    {
                      language.LC()
                        .YOU_CAN_ALWAYS_USE_THE_FLASHCARD_OR_THE_SAVE_QUESTION_TOOLS_TO_TAKE_SOME_NOTES_FOR_LATER
                    }
                  </p>
                  <p>
                    {
                      language.LC()
                        .WE_ENCOURAGE_YOU_TO_LEAVE_YOUR_METHODOLOGY_IN_THE_COMMENTS_SECTION_TO_HELP_OTHER_USERS
                    }
                  </p>
                  <p>
                    {
                      language.LC()
                        .YOU_CAN_LEAVE_THE_QUIZ_AND_COME_BACK_LATER_IT_WILL_ALWAYS_STAY_AVAILABLE_IN_THE_ABANDONED_QUIZZES_SECTION
                    }
                  </p>
                </div>

                <div className='example_box_wrap'>
                  <p className='margin_bottom_20'>
                    <strong>{language.LC().EXAMPLE}</strong>
                  </p>
                  <hr className='margin_bottom_30' />

                  <div className='row'>
                    <div className='col-md-9'>
                      <ul className='list-inline'>
                        <li className='list-inline-item'>
                          <span className='text_light margin_right_20'>
                            {' '}
                            {language.LC().NO_ANSWER}{' '}
                          </span>
                          <span id='quiz_notanswered_status' className='margin_right_60' />
                        </li>
                        <li className='list-inline-item'>
                          <span className='text_light margin_right_20'>
                            {' '}
                            {language.LC().CORRECT_ANSWER}{' '}
                          </span>
                          <span id='quiz_answered_status' className='margin_right_60' />
                        </li>
                        <li className='list-inline-item'>
                          <span className='text_light margin_right_20'>
                            {' '}
                            {language.LC().WRONG_ANSWER}{' '}
                          </span>
                          <span id='quiz_wrong_answered_status' className='margin_right_60' />
                        </li>
                      </ul>
                    </div>
                    <div className='col-md-3 text-right'>{button_status}</div>
                  </div>
                </div>
              </div>
            </div>

            <div className='card'>
              <div className='card-header'>{language.LC().YOUR_ANSWER}</div>
              {case_id_display}
            </div>
          </div>
        </div>

        <ModalComponent
          goPremium={this.goPremium.bind(this)}
          toggleAlert={this.toggleAlert.bind(this)}
          alert_status={this.state.alert_status}
          MessageContent={this.state.MessageContent}
          exam={examNameAccordingToDB.CFA_LEVEL_3}
        />
      </div>
    );
  }
}

class Questionfetch extends React.Component {
  render() {
    let casesquestion = this.props.casesquestion;
    let token = this.props.token;
    let idname = this.props.idname;
    let quiz_id = this.props.quiz_id;
    let answeredstate = this.props.answered_state;
    // let handler=this.props.handler;
    var caseQuestionval = Object.keys(casesquestion).map(function(key) {
      return (
        <tr>
          <td>{parseInt(key) + 1}</td>
          <td id={'questionNameId_' + answeredstate + '_' + key} />
          <td>
            <QuestionFetchcheck
              answered_state={answeredstate + '_' + key}
              question_id={casesquestion[key]}
              token={token}
              idname={idname}
              quiz_id={quiz_id}
            />
          </td>
          {/*<td><a href="javascript: void(0)" onClick = {handler}>View</a></td>*/}
        </tr>
      );
    });
    return <tbody>{caseQuestionval}</tbody>;
  }
}

function QuestionFetchcheck(props) {
  var data = {
    token: props.token,
    idname: props.idname,
    quiz_id: props.quiz_id,
    question_id: props.question_id,
  };
  FD.callAPI(App_data.backend_api + '/cfa_3quizes/checkAnswered', data).then(resp => {
    document.getElementById('questionNameId_' + props.answered_state).innerHTML = resp.questionName;
    //console.log(resp);
    if (resp.success) {
      if (resp.question_recived.answer === 1) {
        document.getElementById('user_question_status_' + props.answered_state).id =
          'quiz_answered_status';
        document.getElementById('answer_flag' + props.answered_state).innerHTML = 'Correct Answer';
      } else {
        document.getElementById('user_question_status_' + props.answered_state).id =
          'quiz_wrong_answered_status';
        document.getElementById('answer_flag' + props.answered_state).innerHTML = 'Wrong Answer';
      }
    } else {
      document.getElementById('user_question_status_' + props.answered_state).id =
        'quiz_notanswered_status';
      document.getElementById('answer_flag' + props.answered_state).innerHTML = 'No Answer';
    }
  });
  return (
    <div>
      <span className='margin_right_20' id={'user_question_status_' + props.answered_state} />
      <span id={'answer_flag' + props.answered_state} />
    </div>
  );
}
export default Cfa3BeforeStart;



// WEBPACK FOOTER //
// ./src/views/CFA3/Cfa3BeforeStart/Cfa3BeforeStart.js